import { render, staticRenderFns } from "./CorporateEmployeesExport.vue?vue&type=template&id=80839c7a&scoped=true"
import script from "./CorporateEmployeesExport.vue?vue&type=script&lang=js"
export * from "./CorporateEmployeesExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80839c7a",
  null
  
)

export default component.exports